




















































































import { PerformoTask, WorkordersApi } from 'performo-api';
import { mapGetters } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
  computed: mapGetters({
    ordersApi: 'ordersApi'
  })
})
export default class ProcedureRowComponent extends Vue {
  @Prop({ required: true, default: undefined })
  private items!: PerformoTask[];
  private prevDataEntry!: string;
  private ordersApi!: WorkordersApi;
  private loading = false;

  private onFocusHandler(data: string) {
    this.prevDataEntry = data;
  }

  private onBlurHandler(task: PerformoTask) {
    if (task.dataEntry != this.prevDataEntry) {
      this.taskUpdate(task, false);
    }
  }

  private async taskUpdate(task: PerformoTask, flipDoneFlag = true) {
    if (!task.workorderId) {
      return;
    }

    this.loading = true;

    let markDone: boolean;
    if ((flipDoneFlag && task.doneFlag) || (!flipDoneFlag && !task.doneFlag)) {
      markDone = false;
    } else {
      markDone = true;
    }

    if (task.taskId) {
      try {
        await this.ordersApi.updateWorkorderTask({
          workorderId: task.workorderId,
          taskId: task.taskId,
          markDone: markDone,
          dataEntry: task.dataEntry?.toString()
        });
        this.$emit('taskUpdate');
      } catch (error) {
        this.$emit('taskUpdateError', error);
        this.$emit('taskUpdate');
      }
    }

    this.loading = false;
  }

  private async mounted() {
    // blank
  }
}
